module.exports = __webpack_public_path__ + "static/img/ptGame3.3d320b9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/ptGame3.webp
// module id = 4e6r
// module chunks = 3